/* ==========================================================
   VERTICAL THUMBNAIL RAIL — arrow button behaviour
   Create this as a new asset: assets/thumbnail-rail.js

   The theme's slider-component scrolls with scrollLeft, which does
   nothing once the thumbnail list is a vertical column. This replaces
   the two arrow buttons (which detaches the theme's listeners) and
   wires them to vertical scrolling instead.
   ========================================================== */

(function () {
  var BREAKPOINT = 750;
  var STEP = 3; // thumbnails moved per arrow click

  function initRail(gallery) {
    var rail = gallery.querySelector('.thumbnail-slider');
    if (!rail || rail.dataset.railInit === 'true') return;

    var list = rail.querySelector('.thumbnail-list');
    if (!list) return;

    rail.dataset.railInit = 'true';

    // Replace the arrows with clones — this strips the theme's horizontal
    // handlers and leaves the theme holding references to detached nodes,
    // so it can no longer force them into a disabled state.
    var buttons = {};
    Array.prototype.forEach.call(rail.children, function (child) {
      if (!child.classList || !child.classList.contains('slider-button')) return;
      var fresh = child.cloneNode(true);
      child.replaceWith(fresh);
      buttons[fresh.name] = fresh;
    });

    function stepDistance() {
      var item = list.querySelector('.thumbnail-list__item');
      if (!item) return list.clientHeight;
      var gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      return (item.getBoundingClientRect().height + gap) * STEP;
    }

    if (buttons.previous) {
      buttons.previous.addEventListener('click', function (event) {
        event.preventDefault();
        list.scrollBy({ top: -stepDistance(), behavior: 'smooth' });
      });
    }

    if (buttons.next) {
      buttons.next.addEventListener('click', function (event) {
        event.preventDefault();
        list.scrollBy({ top: stepDistance(), behavior: 'smooth' });
      });
    }

    function refresh() {
      var overflows = list.scrollHeight > list.clientHeight + 1;
      var atTop = list.scrollTop <= 1;
      var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;

      if (buttons.previous) buttons.previous.toggleAttribute('disabled', !overflows || atTop);
      if (buttons.next) buttons.next.toggleAttribute('disabled', !overflows || atEnd);

      rail.classList.toggle('thumbnail-rail--static', !overflows);
    }

    list.addEventListener('scroll', refresh, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(list);
    window.addEventListener('resize', refresh);
    refresh();

    // Keep the active thumbnail in view when the variant or main image changes.
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          var el = record.target;
          if (el.getAttribute && el.getAttribute('aria-current') === 'true') {
            var item = el.closest('.thumbnail-list__item');
            if (item) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
      }).observe(list, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-current'],
      });
    }
  }

  function initAll() {
    if (window.innerWidth < BREAKPOINT) return;
    document.querySelectorAll("media-gallery[data-desktop-layout^='thumbnail']").forEach(initRail);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  window.addEventListener('resize', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();